import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { MatInput } from '@angular/material/input';
import { Subscription } from 'rxjs';
import { BaseInputComponent } from '../base-input/base-input.component';
import { DateInputType } from '../form.types';
import { QuestionStateService } from '../question-state.service';

@Component({
    selector: 'app-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class DatePickerComponent extends BaseInputComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() input: DateInputType;
    @ViewChild(MatInput) inputElement: MatInput;
    constructor(private questionStateService: QuestionStateService, private changeDetection: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        super.initialize(this.input, this.questionStateService);
    }

    ngAfterViewInit() {
        if (this.inputElement) {
            this.inputIdEvent.emit(this.inputElement.id);
        }
        this.changeDetection.detectChanges();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    updateDependantValueControl(): void {}
}
